import { NewReceivedData } from 'modules/core/domain/interfaces/supabase/received-data';
import { GameInfoMapped } from 'modules/overlay-v2/domain/interfaces/game-info/gameInfoMapped';
import parseInfoEvent from 'modules/overlay-v2/store/game-info/utils/parse-info.event';
import { getScorerIndex } from 'shared/utils/match-event-players';

export async function updateMembersStats(gameInfo: GameInfoMapped, data: NewReceivedData) {
  if (!gameInfo.match) return;
  if (!gameInfo.teams) return;
  if (!gameInfo.teams.firstTeam) return;
  if (!gameInfo.teams.secondTeam) return;

  const teams = { first: gameInfo.teams.firstTeam, second: gameInfo.teams.secondTeam };

  for (const receivedEvent of data?.chronology ?? []) {
    // Игрока ищем через `parseInfoEvent` — сначала команда по `teamId`, потом игрок в ней.
    // Так же разбирает события живой эфир (`parseEvent` в слайсе); общий поиск по обоим
    // составам расходился с ним на противоречивых событиях, и одно и то же событие
    // считалось по-разному при синхронизации и в эфире.
    // Гол у «паса и гола» принадлежит второму игроку события — индекс считает `getScorerIndex`.
    const { player: member } = parseInfoEvent(receivedEvent, teams, { playerIndex: getScorerIndex(receivedEvent.type) });
    if (!member) continue;
    switch (receivedEvent.type) {
      case 'GOAL':
      case 'PENALTY_GOAL':
      case 'PASS_AND_GOAL':
        member.qtyGoalsMatch += 1;
        break;
      case 'AFTER_MATCH_PENALTY_GOAL':
        member.qtyShootoutGoalsMatch += 1;
        break;
      case 'AFTER_MATCH_PENALTY_MISSED':
        member.qtyShootoutMissesMatch += 1;
        break;
      case 'RED_CARD':
        member.qtyRedCardsMatch += 1;
        break;
      case 'YELLOW_CARD':
        member.qtyYellowCardsMatch += 1;
        break;
      case 'FOUL':
        member.qtyFoulsMatch += 1;
        break;
    }
  }

  return gameInfo;
}
